import React, { useEffect, useState, useContext, useRef } from 'react';
import { ConfigContext } from "../../App";
import { useHistory, useParams } from "react-router-dom";
import parse from 'html-react-parser';
import { SubscriptionService } from '../../models/subscription-service';
import { ServiceRegistry } from '../../models/service-registry';
import Spinner from '../spinner/spinner';
import ProductTile from '../producttile/producttile'
import PNSHeader from '../pnsheader/pnsheader';
import { IMS_EVENT, OMEGA_ENV } from '../../constants';
import OMEGA from '../../omega';
import GenericError from '../genericerror/genericerror';
import { HideFooter } from '../../utils';
import { BsoMapping } from '../../models/mapping-service';

export default function UnSubscribeProduct(props: any) {

    const eventDefaultValue = {
        element: "UnSubscribe Product",
        action: "click",
        type: "Component",
        widget: {
            name: "unsubscribeproduct",
            type: "component"
        }
    }

    function omega_capture(element: any, widget_name: any, widget_type: any) {
        OMEGA.init().updateAndTrack("event", [{
            ...eventDefaultValue,
            element: element,
            widget: {
                name: widget_name,
                type: widget_type
            },
        }]);
    }

    const [bsomapping, setBsoMapping] = useState<any>({});
    const [pageLoading, setPageLoading] = useState(true);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [apiError, setApiError] = useState(false);
    const [selfSubscriptions, setSelfSubscriptions] = useState([]);
    const [slackSubscriptions, setSlackSubscriptions] = useState<any>({});
    const [slackNotificationEnabled, setSlackNotificationEnabled] = useState(false);
    const [userLanguage, setUserLanguage] = useState('');
    const [email, setEmail] = useState('');
    const [langInfo, setLangInfo] = useState(false);
    const [timeZoneInfo, setTimeZoneInfo] = useState(false);
    const [timeZone, setTimeZone] = useState();
    const [timezoneString, setTimeZoneString] = useState();
    const [mounted, setMounted] = useState(true);
    const locales = useContext(ConfigContext).appConfig.languageData;

    const historyAPI = useHistory();
    const { productId }: any = useParams();
    
    const doneButtonRef = useRef<HTMLButtonElement>(null);
    const cancelButtonRef = useRef<HTMLButtonElement>(null);

    const subscriptionService: SubscriptionService = SubscriptionService.init();
    subscriptionService.setLocales(locales);
    const serviceRegistry: ServiceRegistry = ServiceRegistry.init();
    subscriptionService.setLocales(locales);
    const bsoMapping: BsoMapping = BsoMapping.init();

    useEffect(() => {

        setPageLoading(true);
        if (window.adobeIMS) {
            getData();
        } else {
            document.addEventListener(IMS_EVENT, getData);
        }

        return () => {
            setMounted(false);
            document.removeEventListener(IMS_EVENT, getData);
        }
    }, []);

    function getData() {
        if (!window.adobeIMS?.isSignedInUser()) {
            window.adobeid.redirect_uri = window.location.href;
            window.adobeIMS.signIn();
            return;
        }

        setUserLanguage(subscriptionService.getUserDetail().userLanguage);
        setEmail(subscriptionService.getUserDetail().email);
        const [
            servicePromise,
            subscriptionPromise,
            slackSubscriptionPromise
        ]: any = [
                serviceRegistry.fetch(),
                subscriptionService.getSubscriptions("product"),
                subscriptionService.getSlackSubscription()
            ];
        window.scrollTo(0, 0);

        Promise.all([subscriptionPromise, slackSubscriptionPromise, servicePromise, bsoMapping.fetch(true)])
            .then((result: any) => [result[0].data, result[1].data, result[2].data, result[3].data])
            .then((result: any) => {
                if (mounted) {
                    setBsoMapping(result[3]);
                    let [subscriptionData, slackSubscriptionData]: any = result;
                    if (slackSubscriptionData?.channel && slackSubscriptionData?.active) {
                        setSlackSubscriptions(slackSubscriptionData);
                    }
                    window.scrollTo(0, 0);

                    setTimeZone(subscriptionData.timeZone);
                    setSlackNotificationEnabled(subscriptionData.slackNotificationEnabled);
                    let timeZoneString: any = `${subscriptionData.timeZone} (${subscriptionData.timezoneOffset})`;
                    setTimeZoneString(timeZoneString);
                    let selfSubs = serviceRegistry.mergeOfferingsIntoProduct(subscriptionData);
                    setSelfSubscriptions(selfSubs || []);
                    setPageLoading(false);
                }
            })
            .catch((error: any) => {
                console.error('Error in unsubscribeproduct service promises:', error);
                omega_capture(
                    `Error in unsubscribeproduct service promises: ${error.message || error.toString()}`,
                    "unsubscribeproduct",
                    "error"
                );
                setError(true);
                setPageLoading(false);
            });
    }

    function unSubscribeProduct() {
        setLoading(true);
        subscriptionService.unSubscribeProduct(productId, selfSubscriptions, timeZone, slackNotificationEnabled)
            .then(() => {
                OMEGA.init().updateAndTrack('page', {
                    hierarchy: "home:manage-subscription:unsubscribe-product",
                    name: "PNS - Unsubscribe Product- Adobe status",
                    url: encodeURIComponent(window.location.href),
                    type: "pns",
                    env: OMEGA_ENV
                });
                setLoading(false);
                redirect();
            }).catch((error: any) => {
                console.error('Error in unsubscribeproduct unsubscribe product:', error);
                omega_capture(
                    `Error in unsubscribeproduct unsubscribe product: ${error.message || error.toString()}`,
                    "unsubscribeproduct",
                    "error"
                );
                setLoading(false);
                setApiError(true);
            });
    }

    function redirect() {
        historyAPI.push({
            pathname: `/proactive-notifications/manage`,
            state: {
                tab: "product",
                page: 'pns'
            }
        })
    }

    return (
        <div className="unsubscribe-product-container">
            <PNSHeader></PNSHeader>
            {
                pageLoading ?
                    <>{HideFooter(true)}<Spinner /></> :<>
                    {HideFooter(false)}
                    <div className="container">
                        {
                            error ? <GenericError /> :
                                <div className="unsubscribe-product">
                                    <div className="title">{locales.unsubscribe_updates}</div>
                                    <div>
                                        {locales.un_future_products} 
                                        <a 
                                            href="#" 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                // Add your learn more functionality here
                                                window.open('https://helpx.adobe.com/enterprise/using/adobe-status.html', '_blank');
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    window.open('https://helpx.adobe.com/enterprise/using/adobe-status.html', '_blank');
                                                }
                                            }}
                                            tabIndex={0}
                                            aria-label="Learn more about subscription management"
                                        >
                                            Learn more
                                        </a>
                                    </div>
                                    <div className="preference">
                                        <div>{locales.sb_email}: <b>{email}</b></div>
                                        {
                                            slackSubscriptions.channel ? <div>{locales.slack}: <b>{slackSubscriptions.channel}</b></div> : <></>
                                        }
                                        <div>{locales.sb_lang}: <b>{userLanguage}</b><i className="info-icon" onClick={() => { setLangInfo(!langInfo); }} /></div>
                                        {langInfo ? <div className="lang-info">{parse(locales.lang_info)}</div> : ""}
                                        <div>{locales.timezone}: <b>{timezoneString}</b><i className="info-icon" onClick={() => { setTimeZoneInfo(!timeZoneInfo); }} /></div>
                                        {timeZoneInfo ? <div className="lang-info">{parse(locales.timezone_info)}</div> : ""}
                                    </div>
                                    <div>
                                        <ProductTile subscription={selfSubscriptions.filter((sub: any) => sub.product.id === productId)[0]} mappingObj={bsomapping} />
                                    </div>
                                    <div className="clearfix">
                                        <div className="unsubscribe-btn">
                                            <button 
                                                onClick={() => { redirect() }} 
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        redirect();
                                                    }
                                                }}
                                                className="btn"
                                                aria-label={locales.cancel_txt}
                                                ref={cancelButtonRef}
                                                tabIndex={0}
                                            >
                                                {locales.cancel_txt}
                                            </button>
                                            <button 
                                                onClick={() => { unSubscribeProduct() }} 
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        if (!loading) {
                                                            unSubscribeProduct();
                                                        }
                                                    }
                                                }}
                                                disabled={loading} 
                                                className={`btn primary ${loading ? 'loading' : ''}`}
                                                aria-label={locales.sb_done}
                                                ref={doneButtonRef}
                                                tabIndex={0}
                                            >
                                                {locales.sb_done}{loading ? <Spinner isButton={true} /> : ''}
                                            </button>
                                        </div>
                                    </div>
                                    {apiError ? <div className="error-info" onClick={() => { historyAPI.push('/') }}>{parse(locales.api_error)}</div> : ""}
                                </div>
                        }
                    </div></>
            }
        </div>
    );
}